<template>
  <div class="container-md container-app p-0 ">
    <div class="wrapper">
      <div class="header"><h1>{{$t('ristorante_orario_titolo')}}</h1></div>
      <div class="content-full">
        <div class="title">{{$t('layout_orari')}}</div>
        <hr>
          <table class="table table-borderless table-sm" style="max-width:350px; margin:10px auto 0;">
            <tbody>
            <tr v-for="(opening, i) in this.opening_hours"
                :key="i">
              <td width="70">
                <b>
                  {{
                    moment((i >= 6 ? 0 : (i + 1)), "d").locale(language)
                        .format("ddd").toUpperCase()
                  }}
                </b>
              </td>
              <td :width="opening.length > 1 ? 140:280" :class="{'red': opening[0] === 'chiuso'}">
                {{opening[0] === 'chiuso' ? $t('chiuso') : opening[0]}}
              </td>
              <td v-if="opening.length > 1" width="140" :class="{'red': opening[1] === 'chiuso'}">
                {{opening[1] === 'chiuso' ? $t('chiuso') : opening[1]}}
              </td>
            </tr>
            </tbody>
          </table>
          <!-- CHIUSURE -->
          <div v-if="this.configurazione_chiusure.length">
            <div class="f1 text-center red">{{$t('ristorante_chiusure_title')}}:</div>
            <p class="text-center m-0" v-for="closure in this.configurazione_chiusure">
              <span class="text-capitalize">{{$t('dal')}}</span>
              {{moment(closure.dal_giorno).format("DD/MM/YYYY")}} {{$t('al')}}
              {{moment(closure.al_giorno).format("DD/MM/YYYY")}} -
              {{closure.traduzione_ll ? closure.traduzione_ll.messaggio : null}}
            </p>
          </div>

        <!-- dove siamo-->
        <div class="content mt-4">
          <p class="text-center"><b class="f4">{{this.locale.nome_locale}}</b><br>
            {{this.locale.indirizzo}}, {{this.locale.civico}}<br>
            {{this.locale.cap}} - {{this.locale.citta}} ({{this.locale.provincia}})<br>
            <i class="fa fa-phone fa-flip-horizontal mr-1"></i>
            <a :href="'tel:'+this.locale.telefono" class="a2">
              {{this.locale.telefono}}
            </a> &nbsp;
            <i class="fa fa-envelope mr-1"></i>{{this.locale.email}}
          </p>
          <p class="text-center mb-0 pb-3 d-none d-md-block">{{this.locale.ragione_sociale}} - {{$t("piva")}} {{this.locale.piva}}</p>
        </div>

        <iframe v-if="this.locale.latitudine && this.locale.longitudine" class="w-100" height="200" frameborder="0"
                scrolling="no" marginheight="0" marginwidth="0"
                :src="`https://maps.google.com/maps?q=${this.locale_address}&t=&z=14&ie=UTF8&iwloc=&output=embed`"></iframe>
      </div>
    </div>

  </div>
</template>
<script>
import {mapState, mapGetters, mapActions} from 'vuex';
import {getImage} from "../api/core";
import {getFidelityCard, getMixedInfo} from "../api/restaurant";
import IconInfo from "../components/IconInfo.vue";
import IconTime from "../components/IconTime.vue";
import IconNews from "../components/IconNews.vue";
import IconNotify from "../components/IconNotify.vue";
import IconOrderHome from "../components/IconOrderHome.vue";

export default {
  components: {IconOrderHome, IconNotify, IconNews, IconTime, IconInfo},
  data() {
    return {
      fidelity_card_promozione: null,
      configurazione_chiusure: [],
      news: [],
      info_locale: []
    }
  },
  created() {
    this.fetchInfo();
  },
  computed: {
    locale_photos: function () {
      if (this.info_locale && this.info_locale.foto) {
        return this.info_locale.foto;
      }

      return [];
    },
    locale_image: function () {
      try {
        const code = this.info_locale.foto[0].codice;

        return getImage(this.language, this.id_ristorante, code);
      } catch (e) {
        return null;
      }
    },
    fidelity_card_percentage: function () {
      try {
        return parseInt(this.fidelity_card_promozione.punteggio_personale / this.fidelity_card_promozione.punteggio_massimo * 100);
      } catch (e) {
        return 0;
      }
    },
    service_point: function () {
      if (this.f_modalita_fiera) {
        return this.punti_di_servizio.find((point) => {
          return point.id === this.id_punto_di_servizio
        });
      }

      return null;
    },
    ...mapGetters('restaurant', {
      enable_reservations: 'enableReservations',
      enable_fidelity_card: 'enableFidelityCard',
      opening_hours: 'openingHours',
      locale_address: 'localeAddress',
      getLocaleImageCode: 'localeImageCode',
      getLocaleDescription: 'localeDescription',
    }),
    ...mapGetters('auth', {
      userAuthenticated: 'authenticated'
    }),
    ...mapState('localization', {
      language: state => state.language
    }),
    ...mapState('restaurant', {
      targa: state => state.targa,
      locale: state => state.locale,
      id_ristorante: state => state.id,
      punti_di_servizio: state => state.punti_di_servizio,
      f_modalita_fiera: state => state.f_modalita_fiera
    }),
    ...mapState('auth', {
      user: state => state
    }),
    ...mapState('global', {
      loading_visible: state => state.loading_visible
    }),
    ...mapState('order', {
      id_punto_di_servizio: state => state.id_punto_di_servizio
    })
  },
  watch: {
    language: function () {
      this.fetchInfo();
    },
    userAuthenticated: function () {
      this.fetchInfo();
    }
  },
  methods: {
    fetchInfo: function () {
      this.showLoading(true);
      axios.all([
        getMixedInfo(this.language, {
          id_ristorante: this.id_ristorante,
          id_locale: this.locale.id,
          configurazione_chiusure: true,
          news: true,
          news_limit: 1,
          info_locale: true
        }),
        getFidelityCard(this.language, {
          id_ristorante: this.id_ristorante,
          id_locale: this.locale.id,
          email: this.user.email,
          api_key: this.user.api_key
        })
      ]).then(axios.spread((...responses) => {
        // use/access the results
        const responseMixed = responses[0];
        const responseFidelity = responses[1];

        this.configurazione_chiusure = responseMixed.configurazione_chiusure;
        this.news = responseMixed.news;
        this.info_locale = responseMixed.info_locale;
        this.fidelity_card_promozione = responseFidelity;

      })).catch(messages => {
        // react on errors.
        alert(messages.join("\n"));
      }).finally(() => {
        if (this.loading_visible) {
          this.showLoading(false);
        }
      });
    },
    getNewsImage: function (news) {
      return getImage(this.language, this.id_ristorante, news.foto_codice);
    },
    displayNewsText: function (news) {
      return news.traduzione.testo > 200 ?
          news.traduzione.testo.substr(0, 200) + ' ... ' : news.traduzione.testo
    },
    ...mapActions('global', [
      'showLoading'
    ])
  }
}
</script>